// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import * as ArchivesAPI from "./archives.mjs";
import { Archives, } from "./archives.mjs";
import * as BlocksAPI from "./blocks.mjs";
import { Blocks, } from "./blocks.mjs";
import * as FilesAPI from "./files.mjs";
import { Files, } from "./files.mjs";
import * as FoldersAPI from "./folders.mjs";
import { Folders, } from "./folders.mjs";
import * as IdentitiesAPI from "./identities.mjs";
import { Identities, } from "./identities.mjs";
import * as MessagesAPI from "./messages.mjs";
import { Messages, } from "./messages.mjs";
import * as PassagesAPI from "./passages.mjs";
import { Passages, } from "./passages.mjs";
import * as ScheduleAPI from "./schedule.mjs";
import { Schedule, } from "./schedule.mjs";
import * as AgentsToolsAPI from "./tools.mjs";
import { Tools, } from "./tools.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { buildHeaders } from "../../internal/headers.mjs";
import { multipartFormRequestOptions } from "../../internal/uploads.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Agents extends APIResource {
    constructor() {
        super(...arguments);
        this.messages = new MessagesAPI.Messages(this._client);
        this.schedule = new ScheduleAPI.Schedule(this._client);
        this.blocks = new BlocksAPI.Blocks(this._client);
        this.tools = new AgentsToolsAPI.Tools(this._client);
        this.folders = new FoldersAPI.Folders(this._client);
        this.files = new FilesAPI.Files(this._client);
        this.archives = new ArchivesAPI.Archives(this._client);
        this.passages = new PassagesAPI.Passages(this._client);
        this.identities = new IdentitiesAPI.Identities(this._client);
    }
    /**
     * Create an agent.
     */
    create(body, options) {
        return this._client.post('/v1/agents/', { body, ...options });
    }
    /**
     * Get the state of the agent.
     */
    retrieve(agentID, query = {}, options) {
        return this._client.get(path `/v1/agents/${agentID}`, { query, ...options });
    }
    /**
     * Update an existing agent.
     */
    update(agentID, body, options) {
        return this._client.patch(path `/v1/agents/${agentID}`, { body, ...options });
    }
    /**
     * Get a list of all agents.
     */
    list(query = {}, options) {
        return this._client.getAPIList('/v1/agents/', (ArrayPage), { query, ...options });
    }
    /**
     * Delete an agent.
     */
    delete(agentID, options) {
        return this._client.delete(path `/v1/agents/${agentID}`, options);
    }
    /**
     * Export the serialized JSON representation of an agent, formatted with
     * indentation.
     */
    exportFile(agentID, query = {}, options) {
        return this._client.get(path `/v1/agents/${agentID}/export`, { query, ...options });
    }
    /**
     * Import a serialized agent file and recreate the agent(s) in the system. Returns
     * the IDs of all imported agents.
     */
    importFile(params, options) {
        const { 'x-override-embedding-model': xOverrideEmbeddingModel, ...body } = params;
        return this._client.post('/v1/agents/import', multipartFormRequestOptions({
            body,
            ...options,
            headers: buildHeaders([
                {
                    ...(xOverrideEmbeddingModel != null ?
                        { 'x-override-embedding-model': xOverrideEmbeddingModel }
                        : undefined),
                },
                options?.headers,
            ]),
        }, this._client));
    }
    /**
     * Manually trigger system prompt recompilation for an agent.
     */
    recompile(agentID, params = {}, options) {
        const { dry_run, update_timestamp } = params ?? {};
        return this._client.post(path `/v1/agents/${agentID}/recompile`, {
            query: { dry_run, update_timestamp },
            ...options,
        });
    }
}
Agents.Messages = Messages;
Agents.Schedule = Schedule;
Agents.Blocks = Blocks;
Agents.Tools = Tools;
Agents.Folders = Folders;
Agents.Files = Files;
Agents.Archives = Archives;
Agents.Passages = Passages;
Agents.Identities = Identities;
//# sourceMappingURL=agents.mjs.map